module.exports = __webpack_public_path__ + "b7feda35f1f3fcd8a0ce54d08ae6d1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModulesLanding/module3.png
// module id = 1380
// module chunks = 0